/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  CalendarFeedAddRequest,
  CalendarFeedItemViewModel,
  CalendarFeedUpdateRequest,
  ExcelExportRequestParamsWithJobParams,
  GetDynamicGridViewsListResponse,
  LinkScheduleToTaskRequest,
  MarkCompleteRequest,
  PatchScheduleRequest,
  RecalculateScheduleRequest,
  ScheduleDynamicGridResponse,
  ScheduleHistoryResponse,
  ScheduleLinkedTasksResponse,
  SchedulePatchResponse,
  SchedulesExternalCalendarGetV2Params,
  SchedulesGridRequest,
  SchedulesGridViewsRequest,
  SchedulesHistoryByJobIdGetV2Params,
  SchedulesLegacyExternalCalendarGetV2Params,
  SchedulesRangeGetV2Params,
  SchedulesRangeResponse,
  UpdatedSchedule,
  WorkdayExceptionsJobData,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesCalendarFeedPostV2 = (
  calendarFeedAddRequest: BodyType<CalendarFeedAddRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<CalendarFeedItemViewModel>(
    {
      url: `/apix/v2/Schedules/calendar-feed`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: calendarFeedAddRequest,
      signal,
    },
    options,
  );
};

export const getSchedulesCalendarFeedPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>,
    TError,
    { data: BodyType<CalendarFeedAddRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>,
  TError,
  { data: BodyType<CalendarFeedAddRequest> },
  TContext
> => {
  const mutationKey = ["schedulesCalendarFeedPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>,
    { data: BodyType<CalendarFeedAddRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesCalendarFeedPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesCalendarFeedPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>
>;
export type SchedulesCalendarFeedPostV2MutationBody =
  BodyType<CalendarFeedAddRequest>;
export type SchedulesCalendarFeedPostV2MutationError = ErrorType<unknown>;

export const useSchedulesCalendarFeedPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>,
    TError,
    { data: BodyType<CalendarFeedAddRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesCalendarFeedPostV2>>,
  TError,
  { data: BodyType<CalendarFeedAddRequest> },
  TContext
> => {
  const mutationOptions =
    getSchedulesCalendarFeedPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesCalendarFeedPutV2 = (
  calendarFeedUpdateRequest: BodyType<CalendarFeedUpdateRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<CalendarFeedItemViewModel>(
    {
      url: `/apix/v2/Schedules/calendar-feed`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: calendarFeedUpdateRequest,
    },
    options,
  );
};

export const getSchedulesCalendarFeedPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>,
    TError,
    { data: BodyType<CalendarFeedUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>,
  TError,
  { data: BodyType<CalendarFeedUpdateRequest> },
  TContext
> => {
  const mutationKey = ["schedulesCalendarFeedPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>,
    { data: BodyType<CalendarFeedUpdateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesCalendarFeedPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesCalendarFeedPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>
>;
export type SchedulesCalendarFeedPutV2MutationBody =
  BodyType<CalendarFeedUpdateRequest>;
export type SchedulesCalendarFeedPutV2MutationError = ErrorType<unknown>;

export const useSchedulesCalendarFeedPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>,
    TError,
    { data: BodyType<CalendarFeedUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesCalendarFeedPutV2>>,
  TError,
  { data: BodyType<CalendarFeedUpdateRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesCalendarFeedPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesRangeGetV2 = (
  params?: SchedulesRangeGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<SchedulesRangeResponse>(
    { url: `/apix/v2/Schedules/range`, method: "GET", params, signal },
    options,
  );
};

export const getSchedulesRangeGetV2QueryKey = (
  params?: SchedulesRangeGetV2Params,
) => {
  return [`/apix/v2/Schedules/range`, ...(params ? [params] : [])] as const;
};

export const getSchedulesRangeGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesRangeGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesRangeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesRangeGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSchedulesRangeGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesRangeGetV2>>
  > = ({ signal }) => schedulesRangeGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesRangeGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesRangeGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesRangeGetV2>>
>;
export type SchedulesRangeGetV2QueryError = ErrorType<unknown>;

export function useSchedulesRangeGetV2<
  TData = Awaited<ReturnType<typeof schedulesRangeGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesRangeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesRangeGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesRangeGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesExportPostV2 = (
  excelExportRequestParamsWithJobParams: BodyType<ExcelExportRequestParamsWithJobParams>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Schedules/export`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: excelExportRequestParamsWithJobParams,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getSchedulesExportPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesExportPostV2>>,
    TError,
    { data: BodyType<ExcelExportRequestParamsWithJobParams> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesExportPostV2>>,
  TError,
  { data: BodyType<ExcelExportRequestParamsWithJobParams> },
  TContext
> => {
  const mutationKey = ["schedulesExportPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesExportPostV2>>,
    { data: BodyType<ExcelExportRequestParamsWithJobParams> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesExportPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesExportPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesExportPostV2>>
>;
export type SchedulesExportPostV2MutationBody =
  BodyType<ExcelExportRequestParamsWithJobParams>;
export type SchedulesExportPostV2MutationError = ErrorType<unknown>;

export const useSchedulesExportPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesExportPostV2>>,
    TError,
    { data: BodyType<ExcelExportRequestParamsWithJobParams> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesExportPostV2>>,
  TError,
  { data: BodyType<ExcelExportRequestParamsWithJobParams> },
  TContext
> => {
  const mutationOptions = getSchedulesExportPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `stable`
 */
export const schedulesExternalCalendarGetV2 = (
  params?: SchedulesExternalCalendarGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Schedules/external-calendar`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getSchedulesExternalCalendarGetV2QueryKey = (
  params?: SchedulesExternalCalendarGetV2Params,
) => {
  return [
    `/apix/v2/Schedules/external-calendar`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSchedulesExternalCalendarGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesExternalCalendarGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSchedulesExternalCalendarGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>
  > = ({ signal }) =>
    schedulesExternalCalendarGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesExternalCalendarGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>
>;
export type SchedulesExternalCalendarGetV2QueryError = ErrorType<unknown>;

export function useSchedulesExternalCalendarGetV2<
  TData = Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesExternalCalendarGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesExternalCalendarGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesExternalCalendarGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const schedulesLegacyExternalCalendarGetV2 = (
  params?: SchedulesLegacyExternalCalendarGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<Blob>(
    {
      url: `/apix/v2/Schedules/legacy-external-calendar`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options,
  );
};

export const getSchedulesLegacyExternalCalendarGetV2QueryKey = (
  params?: SchedulesLegacyExternalCalendarGetV2Params,
) => {
  return [
    `/apix/v2/Schedules/legacy-external-calendar`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSchedulesLegacyExternalCalendarGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesLegacyExternalCalendarGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSchedulesLegacyExternalCalendarGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>
  > = ({ signal }) =>
    schedulesLegacyExternalCalendarGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesLegacyExternalCalendarGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>
>;
export type SchedulesLegacyExternalCalendarGetV2QueryError = ErrorType<unknown>;

export function useSchedulesLegacyExternalCalendarGetV2<
  TData = Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: SchedulesLegacyExternalCalendarGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesLegacyExternalCalendarGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesLegacyExternalCalendarGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesHistoryByJobIdGetV2 = (
  jobId: number,
  params?: SchedulesHistoryByJobIdGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleHistoryResponse>(
    {
      url: `/apix/v2/Schedules/${jobId}/history`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getSchedulesHistoryByJobIdGetV2QueryKey = (
  jobId?: number,
  params?: SchedulesHistoryByJobIdGetV2Params,
) => {
  return [
    `/apix/v2/Schedules/${jobId}/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSchedulesHistoryByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  params?: SchedulesHistoryByJobIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSchedulesHistoryByJobIdGetV2QueryKey(jobId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>
  > = ({ signal }) =>
    schedulesHistoryByJobIdGetV2(jobId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesHistoryByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>
>;
export type SchedulesHistoryByJobIdGetV2QueryError = ErrorType<unknown>;

export function useSchedulesHistoryByJobIdGetV2<
  TData = Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  params?: SchedulesHistoryByJobIdGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesHistoryByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesHistoryByJobIdGetV2QueryOptions(
    jobId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesMarkCompletePutV2 = (
  markCompleteRequest: BodyType<MarkCompleteRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Schedules/mark-complete`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: markCompleteRequest,
    },
    options,
  );
};

export const getSchedulesMarkCompletePutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>,
    TError,
    { data: BodyType<MarkCompleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>,
  TError,
  { data: BodyType<MarkCompleteRequest> },
  TContext
> => {
  const mutationKey = ["schedulesMarkCompletePutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>,
    { data: BodyType<MarkCompleteRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesMarkCompletePutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesMarkCompletePutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>
>;
export type SchedulesMarkCompletePutV2MutationBody =
  BodyType<MarkCompleteRequest>;
export type SchedulesMarkCompletePutV2MutationError = ErrorType<unknown>;

export const useSchedulesMarkCompletePutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>,
    TError,
    { data: BodyType<MarkCompleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesMarkCompletePutV2>>,
  TError,
  { data: BodyType<MarkCompleteRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesMarkCompletePutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @deprecated
 */
export const schedulesGridviewsPostV2 = (
  schedulesGridViewsRequest: BodyType<SchedulesGridViewsRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetDynamicGridViewsListResponse>(
    {
      url: `/apix/v2/Schedules/gridviews`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: schedulesGridViewsRequest,
      signal,
    },
    options,
  );
};

export const getSchedulesGridviewsPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesGridviewsPostV2>>,
    TError,
    { data: BodyType<SchedulesGridViewsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesGridviewsPostV2>>,
  TError,
  { data: BodyType<SchedulesGridViewsRequest> },
  TContext
> => {
  const mutationKey = ["schedulesGridviewsPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesGridviewsPostV2>>,
    { data: BodyType<SchedulesGridViewsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesGridviewsPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesGridviewsPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesGridviewsPostV2>>
>;
export type SchedulesGridviewsPostV2MutationBody =
  BodyType<SchedulesGridViewsRequest>;
export type SchedulesGridviewsPostV2MutationError = ErrorType<unknown>;

/**
 * @deprecated
 */
export const useSchedulesGridviewsPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesGridviewsPostV2>>,
    TError,
    { data: BodyType<SchedulesGridViewsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesGridviewsPostV2>>,
  TError,
  { data: BodyType<SchedulesGridViewsRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesGridviewsPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesPatchV2 = (
  patchScheduleRequest: BodyType<PatchScheduleRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<SchedulePatchResponse>(
    {
      url: `/apix/v2/Schedules`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: patchScheduleRequest,
    },
    options,
  );
};

export const getSchedulesPatchV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesPatchV2>>,
    TError,
    { data: BodyType<PatchScheduleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesPatchV2>>,
  TError,
  { data: BodyType<PatchScheduleRequest> },
  TContext
> => {
  const mutationKey = ["schedulesPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesPatchV2>>,
    { data: BodyType<PatchScheduleRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesPatchV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesPatchV2>>
>;
export type SchedulesPatchV2MutationBody = BodyType<PatchScheduleRequest>;
export type SchedulesPatchV2MutationError = ErrorType<unknown>;

export const useSchedulesPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesPatchV2>>,
    TError,
    { data: BodyType<PatchScheduleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesPatchV2>>,
  TError,
  { data: BodyType<PatchScheduleRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesRecalculatePostV2 = (
  recalculateScheduleRequest: BodyType<RecalculateScheduleRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<UpdatedSchedule>(
    {
      url: `/apix/v2/Schedules/recalculate`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: recalculateScheduleRequest,
      signal,
    },
    options,
  );
};

export const getSchedulesRecalculatePostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesRecalculatePostV2>>,
    TError,
    { data: BodyType<RecalculateScheduleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesRecalculatePostV2>>,
  TError,
  { data: BodyType<RecalculateScheduleRequest> },
  TContext
> => {
  const mutationKey = ["schedulesRecalculatePostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesRecalculatePostV2>>,
    { data: BodyType<RecalculateScheduleRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesRecalculatePostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesRecalculatePostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesRecalculatePostV2>>
>;
export type SchedulesRecalculatePostV2MutationBody =
  BodyType<RecalculateScheduleRequest>;
export type SchedulesRecalculatePostV2MutationError = ErrorType<unknown>;

export const useSchedulesRecalculatePostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesRecalculatePostV2>>,
    TError,
    { data: BodyType<RecalculateScheduleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesRecalculatePostV2>>,
  TError,
  { data: BodyType<RecalculateScheduleRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesRecalculatePostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesGridPostV2 = (
  schedulesGridRequest: BodyType<SchedulesGridRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleDynamicGridResponse>(
    {
      url: `/apix/v2/Schedules/grid`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: schedulesGridRequest,
      signal,
    },
    options,
  );
};

export const getSchedulesGridPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesGridPostV2>>,
    TError,
    { data: BodyType<SchedulesGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof schedulesGridPostV2>>,
  TError,
  { data: BodyType<SchedulesGridRequest> },
  TContext
> => {
  const mutationKey = ["schedulesGridPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof schedulesGridPostV2>>,
    { data: BodyType<SchedulesGridRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return schedulesGridPostV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SchedulesGridPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof schedulesGridPostV2>>
>;
export type SchedulesGridPostV2MutationBody = BodyType<SchedulesGridRequest>;
export type SchedulesGridPostV2MutationError = ErrorType<unknown>;

export const useSchedulesGridPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof schedulesGridPostV2>>,
    TError,
    { data: BodyType<SchedulesGridRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesGridPostV2>>,
  TError,
  { data: BodyType<SchedulesGridRequest> },
  TContext
> => {
  const mutationOptions = getSchedulesGridPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesTasksByJobIdAndScheduleIdGetV2 = (
  jobId: number,
  scheduleId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ScheduleLinkedTasksResponse>(
    {
      url: `/apix/v2/Schedules/${jobId}/${scheduleId}/tasks`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSchedulesTasksByJobIdAndScheduleIdGetV2QueryKey = (
  jobId?: number,
  scheduleId?: number,
) => {
  return [`/apix/v2/Schedules/${jobId}/${scheduleId}/tasks`] as const;
};

export const getSchedulesTasksByJobIdAndScheduleIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSchedulesTasksByJobIdAndScheduleIdGetV2QueryKey(jobId, scheduleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>
  > = ({ signal }) =>
    schedulesTasksByJobIdAndScheduleIdGetV2(
      jobId,
      scheduleId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(jobId && scheduleId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesTasksByJobIdAndScheduleIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>
>;
export type SchedulesTasksByJobIdAndScheduleIdGetV2QueryError =
  ErrorType<unknown>;

export function useSchedulesTasksByJobIdAndScheduleIdGetV2<
  TData = Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  scheduleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesTasksByJobIdAndScheduleIdGetV2QueryOptions(
    jobId,
    scheduleId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2 = (
  jobId: number,
  scheduleId: number,
  taskId: number,
  linkScheduleToTaskRequest: BodyType<LinkScheduleToTaskRequest>,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Schedules/${jobId}/${scheduleId}/tasks/${taskId}`,
      method: "POST",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: linkScheduleToTaskRequest,
      signal,
    },
    options,
  );
};

export const getSchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>
      >,
      TError,
      {
        jobId: number;
        scheduleId: number;
        taskId: number;
        data: BodyType<LinkScheduleToTaskRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>
    >,
    TError,
    {
      jobId: number;
      scheduleId: number;
      taskId: number;
      data: BodyType<LinkScheduleToTaskRequest>;
    },
    TContext
  > => {
    const mutationKey = ["schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>
      >,
      {
        jobId: number;
        scheduleId: number;
        taskId: number;
        data: BodyType<LinkScheduleToTaskRequest>;
      }
    > = (props) => {
      const { jobId, scheduleId, taskId, data } = props ?? {};

      return schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2(
        jobId,
        scheduleId,
        taskId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>
    >
  >;
export type SchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2MutationBody =
  BodyType<LinkScheduleToTaskRequest>;
export type SchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2MutationError =
  ErrorType<unknown>;

export const useSchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>
    >,
    TError,
    {
      jobId: number;
      scheduleId: number;
      taskId: number;
      data: BodyType<LinkScheduleToTaskRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2>>,
  TError,
  {
    jobId: number;
    scheduleId: number;
    taskId: number;
    data: BodyType<LinkScheduleToTaskRequest>;
  },
  TContext
> => {
  const mutationOptions =
    getSchedulesTasksByJobIdAndScheduleIdAndTaskIdPostV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2 = (
  jobId: number,
  scheduleId: number,
  taskId: number,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/Schedules/${jobId}/${scheduleId}/tasks/${taskId}`,
      method: "DELETE",
    },
    options,
  );
};

export const getSchedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
      >,
      TError,
      { jobId: number; scheduleId: number; taskId: number },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
    >,
    TError,
    { jobId: number; scheduleId: number; taskId: number },
    TContext
  > => {
    const mutationKey = ["schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
      >,
      { jobId: number; scheduleId: number; taskId: number }
    > = (props) => {
      const { jobId, scheduleId, taskId } = props ?? {};

      return schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2(
        jobId,
        scheduleId,
        taskId,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SchedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2MutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
    >
  >;

export type SchedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2MutationError =
  ErrorType<unknown>;

export const useSchedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
    >,
    TError,
    { jobId: number; scheduleId: number; taskId: number },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof schedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2>
  >,
  TError,
  { jobId: number; scheduleId: number; taskId: number },
  TContext
> => {
  const mutationOptions =
    getSchedulesTasksByJobIdAndScheduleIdAndTaskIdDeleteV2MutationOptions(
      options,
    );

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const schedulesWorkdayExceptionsByJobIdGetV2 = (
  jobId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<WorkdayExceptionsJobData>(
    {
      url: `/apix/v2/Schedules/${jobId}/workday-exceptions`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getSchedulesWorkdayExceptionsByJobIdGetV2QueryKey = (
  jobId?: number,
) => {
  return [`/apix/v2/Schedules/${jobId}/workday-exceptions`] as const;
};

export const getSchedulesWorkdayExceptionsByJobIdGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSchedulesWorkdayExceptionsByJobIdGetV2QueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>
  > = ({ signal }) =>
    schedulesWorkdayExceptionsByJobIdGetV2(jobId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SchedulesWorkdayExceptionsByJobIdGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>
>;
export type SchedulesWorkdayExceptionsByJobIdGetV2QueryError =
  ErrorType<unknown>;

export function useSchedulesWorkdayExceptionsByJobIdGetV2<
  TData = Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>,
  TError = ErrorType<unknown>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof schedulesWorkdayExceptionsByJobIdGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSchedulesWorkdayExceptionsByJobIdGetV2QueryOptions(
    jobId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
